<template>
  <Btn
    label="Video"
    @click="virtualTourClicked"
  />
</template>

<script>
import getPropertyVirtualTourUrl from '../helpers/getPropertyVirtualTourUrl';
import Btn from './Btn.vue';

export default {
  name: 'VirtualTourBtn',
  components: { Btn },
  props: {
    property: {
      type: Object,
      required: true,
    },
  },
  methods: {
    virtualTourClicked() {
      window.open(getPropertyVirtualTourUrl(this.property), '_blank', 'noopener noreferrer');
    },
  },
};
</script>
